export default "__VITE_ASSET__DyWMd3q$__"